import { render } from "./ComandosXeonMC.vue?vue&type=template&id=6553225c&scoped=true"
import script from "./ComandosXeonMC.vue?vue&type=script&lang=js"
export * from "./ComandosXeonMC.vue?vue&type=script&lang=js"

import "./ComandosXeonMC.vue?vue&type=style&index=0&id=6553225c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6553225c"]])

export default __exports__